import { z } from 'zod';

export const warehouseProductSchema = z.object({
  trek_id: z
    .string()
    .trim()
    .min(1, 'warehouse.form.errors.trekIdRequired')
    .max(120, 'warehouse.form.errors.tooLong'),
  name: z.string().trim().max(255, 'warehouse.form.errors.tooLong').optional().or(z.literal('')),
  quantity: z
    .union([z.coerce.number().int().min(0, 'warehouse.form.errors.invalidNumber'), z.nan()])
    .optional(),
  price: z
    .union([z.coerce.number().min(0, 'warehouse.form.errors.invalidNumber'), z.nan()])
    .optional(),
  weight: z
    .union([z.coerce.number().min(0, 'warehouse.form.errors.invalidNumber'), z.nan()])
    .optional(),
  store_name: z
    .string()
    .trim()
    .max(255, 'warehouse.form.errors.tooLong')
    .optional()
    .or(z.literal('')),
  cargo_id_code: z
    .string()
    .trim()
    .max(255, 'warehouse.form.errors.tooLong')
    .optional()
    .or(z.literal('')),
  address: z
    .string()
    .trim()
    .max(255, 'warehouse.form.errors.tooLong')
    .optional()
    .or(z.literal('')),
  note: z.string().trim().max(1000, 'warehouse.form.errors.tooLong').optional().or(z.literal('')),
});

export type WarehouseProductFormValues = z.infer<typeof warehouseProductSchema>;
